import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import router from '@/router';
import SchoolRoles from '@/common/types/school-roles';
import AuthService from '@/services/AuthService';


export default /*#__PURE__*/_defineComponent({
  __name: 'not-found-redirect-component',
  setup(__props) {

onMounted(() => {
    const userRole = localStorage.getItem('role');

    switch (userRole) {
        case SchoolRoles.Teacher:
            router.push({ name: 'sn.teacher.main' });
            break;
        case SchoolRoles.Student:
            router.push({ name: 'sn.student.main' });
            break;
        default:
            AuthService.logout();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})